module.exports = __webpack_public_path__ + "79e41d8cee8dba9b2546e9b94183cd9c.svg";